import React from 'react'
import "./Introduction.css"
import { motion } from "framer-motion";

import cv from "../../Navbar/Chinta-Sivanaryana-Resume.pdf"

const Introduction = () => {


  // 
  return (
    <div className='intro' name='home' data-aos="fade-left"
      data-aos-anchor="#example-anchor"
      data-aos-offset="500"
      data-aos-duration="500">
      {/* <motion.div className="i-left" whileInView={{x:[-500,0], opacity:[0,1]}} transition={{duration:2}}> */}
      <motion.div className="i-left" whileInView={{ x: [-300, 0], opacity: [0, 1] }} transition={{ duration: 2 }}>
        <div className="i-name">
          <span>Hi ! I Am </span>
          <span> Chinta Sivanarayana</span>
          <span id="cont">Full Stack Web Developer with high level of experience in web designing and development, producing the Quality of work.Ability to work on both the front-end and back-end aspects of a web application.</span>
          {/* <a href="https://drive.google.com/file/d/1_nanTUnMvA2yIrPwMjSbeDizTs14krA2/view?usp=share_link" download={true}> <button className="Btn">Download CV</button></a>
        </div> */}
          <a href={cv} smooth="true" onClick={()=>window.open("https://drive.google.com/file/d/1y6IF4HG_ykfG52FxvKLQfMO4h5qulomj/view?usp=share_link")}
            download={'Chinta-Sivanarayana-Resume.pdf'} textDecoration='null' target="_blank" rel="noreferrer"
          >
            <button className="Btn">Download CV</button>
          </a>
        </div>
        {/* //  */}

      </motion.div>
      <motion.div className="i-right" whileInView={{ x: [150, -0], opacity: [0, 1] }} transition={{ duration: 2 }}>
        <img className='me' src="https://i.ibb.co/JCthW8j/1000007178.jpg" alt="1000007178" />
        {/* <div style={{ marginLeft: "80%", marginRight: "10px", marginTop: "-84%", }}>
          <FloatingDiv image={"https://images-workbench.99static.com/3GLSVKjJrPmX9jzl4kY3NuF09RY=/69x0:632x563/fit-in/500x500/filters:fill(white,true)/http://s3.amazonaws.com/projects-files/85/8576/857670/40d6ad18-5826-41f2-ba3d-395856372c1a.gif"} txt1="Web" txt2="Developer" />
        </div> */}
        {/* <div style={{ marginLeft: "80%", marginRight: "10px", marginTop: "60%", }}>
          <FloatingDiv image={"https://images-workbench.99static.com/C3v_nYwR45jZF2_nHP-kpOF-lew=/0x0:1200x1200/fit-in/500x500/filters:fill(white,true)/http://s3.amazonaws.com/projects-files/82/8221/822139/1c5a22d8-cbb8-48d9-ba45-a56ea137ad64.gif"} txt1="Best" txt2="Styling" />
        </div> */}
        {/* Blur */}
        {/* <div className="blur" style={{background:"rgb (238 210 255)"}}></div>
        <div className="blurbot" style={{background:"rgb (238 210 255)"}}></div> */}

      </motion.div>
    </div>
  )
}

export default Introduction